import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableRow,
  Typography,
  withStyles,
} from '@material-ui/core';

export const StyledTableContainer = withStyles((theme) => ({
  root: {
    fontSize: 12,
    maxHeight: 700,
    height: 'calc(100% - 120px)',
    '& .MuiTableSortLabel-root.MuiTableSortLabel-active': {
      color: theme.palette.common.white,
    },
    '& .MuiTableSortLabel-root.MuiTableSortLabel-active.MuiTableSortLabel-root.MuiTableSortLabel-active .MuiTableSortLabel-icon': {
      color: theme.palette.common.white,
    },
  },
}))(TableContainer);

export const StyledTable = withStyles((theme) => ({
  root: {
    border: '1px solid rgba(251,255,57, .3)',
    borderRight: 'none',
    borderBottom: 'none',
    overflow: 'hidden',
    borderRadius: '3px 3px 0px 0px',
    maxHeight: '100%',
    height: '100%',
  },
}))(Table);

export const StyledTableHeaderCell = withStyles((theme) => ({
  root: {
    color: theme.palette.common.white,
    backgroundColor: '#031630',
    borderRight: '1px solid rgba(251,255,57, .3)',
    borderBottom: '1px solid rgba(251,255,57, .3)',
    borderTop: '1px solid rgba(251,255,57, .3)',
    padding: 8,
    fontSize: 14,
    whiteSpace: 'nowrap',
    height: 39,
    maxHeight: 39,
    '& .MuiTableSortLabel-root': {
      '&:hover': {
        color: theme.palette.common.white,
      }
    }
  },
}))(TableCell);

export const StyledTableBody = withStyles((theme) => ({
  root: {
    '&  tr:nth-child(odd)': {
      backgroundColor: '#122A4A',
    },
  },
}))(TableBody);

export const StyledPaginationWrapper = withStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'flex-end',
    border: '1px solid rgba(251,255,57, .3)',
    borderRadius: '0px 0px 3px 3px',
    '& .MuiTableCell-root': {
      color: theme.palette.common.white,
      borderBottom: 'none',
    },
    '& .MuiSvgIcon-root': {
      color: theme.palette.common.white,
    },
  },
}))(TableFooter);

export const StyledTableRow = withStyles((theme) => ({
  root: {
    color: theme.palette.common.white,
    backgroundColor: 'transparent',
    height: 50,
    minHeight: 50,
    maxHeight: 50,
  },
}))(TableRow);

export const StyledTableCell = withStyles((theme) => ({
  root: {
    color: theme.palette.common.white,
    padding: '8px 8px !important',
    borderRight: '1px solid rgba(251,255,57, .3)',
    borderBottom: 'none',
    fontSize: 16,
  },
}))(TableCell);

export const StyledNoOutcomesTableCell = withStyles((theme) => ({
  root: {
    color: theme.palette.common.black,
    padding: '4px 16px !important',
    borderRight: '1px solid rgba(0,0,0,.15)',
    height: 300,
  },
}))(TableCell);

export const StyledImageWrapper = withStyles((theme) => ({
  root: {
    width: 30,
    height: 30,
    display: 'flex',
    justifyContent: 'center',
    marginLeft: 24,
    borderRadius: 4,
    padding: 2,
    '& img': {
      height: '100%',
      width: '100%',
    },
  },
}))(Box);

export const StyledSportsbookImageWrapper = withStyles((theme) => ({
  root: {
    width: 25,
    height: 25,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '4px',
    overflow: 'hidden',
    '& a': {
      height: '100%',
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    '& img': {
      height: '70%',
      width: '70%',
    },
  },
}))(Box);

export const StyledTableParticipantCell = withStyles((theme) => ({
  root: {
    color: theme.palette.common.black,
    padding: '4px 16px !important',
    display: 'flex',
    alignItems: 'center',
    borderRight: '1px solid rgba(0,0,0,.15)',
    [theme.breakpoints.down('sm')]: {
      padding: '4px !important',
    },
  },
}))(TableCell);

export const StyledTableOddsAndLineCell = withStyles((theme) => ({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    '& .odds': {
      fontWeight: 700,
      fontSize: 16,
    },
  },
}))(Box);

export const StyledTableStokasticInfoCell = withStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    padding: '0 8px',
    justifyContent: 'space-around',
    height: '100%',
    '& .info': {
      display: 'flex',
      justifyContent: 'space-between',
    },
  },
}))(Box);

export const TooltipSelectLabelStyledTypography = withStyles((theme) => ({
  root: {
    color: theme.palette.common.white,
    opacity: 0.7,
    fontFamily: 'Inter',
    fontSize: '12px',
    fontStyle: 'normal',
    fontHeight: 500,
  },
}))(Typography);

export const StyledParticipantImageWrapper = withStyles((theme) => ({
  root: {
    width: 30,
    height: 30,
    display: 'flex',
    justifyContent: 'center',
    borderRadius: '100%',
    overflow: 'hidden',
    [theme.breakpoints.down('sm')]: {
      minWidth: 30,
      height: 30,
    },
    '& img': {
      height: '100%',
      width: '100%',
    },
  },
}))(Box);

export const StyledParticipantTwoTeamImageWrapper = withStyles((theme) => ({
  root: {
    width: 30,
    height: 30,
    display: 'flex',
    justifyContent: 'center',
    borderRadius: '100%',
    overflow: 'hidden',
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      minWidth: 30,
      height: 30,
    },
    '& img': {
      position: 'absolute',
      height: '75%',
      width: '75%',
    },
    '& .awayTeam': {
      top: 0,
      left: 0,
    },
    '& .homeTeam': {
      bottom: 0,
      right: 0,
    },
  },
}))(Box);

export const StyledEventDetailsWrapper = withStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: 8,
    '& .participant': {
      fontWeight: 700,
      fontSize: 16,
      maxWidth: 200,
      [theme.breakpoints.down('sm')]: {
        fontSize: 14,
      },
    },
    '& .event': {
      color: theme.palette.grey[800],
      fontSize: 12,
      [theme.breakpoints.down('sm')]: {
        fontSize: 10,
      },
    },
  },
}))(Box);

